import config from 'ra-config'
import { learnMoreUrl } from 'lib/config/learn-more'

const REPLACEMENTS = [
  {
    pattern: /\{coreSiteBaseUrl\}/g,
    replace: () => config.env.coreSiteBaseUrl
  },
  {
    pattern: /\{rafiSiteBaseUrl\}/g,
    replace: () => config.env.rafiSiteBaseUrl
  },
  {
    pattern: /\{learnMoreUrl\}/g,
    replace: () => learnMoreUrl()
  },
  {
    pattern: /\{publicPath\}/g,
    replace: () => process.env.PUBLIC_PATH
  },
  {
    pattern: /\{sourceText\}/g,
    replace: () => config.content.sourceText
  },
  {
    pattern: /\{dataDateText\}/g,
    replace: () => config.content.dataDateText
  },
  {
    pattern: /\{dataDate\}/g,
    replace: () => config.app.dataDate
  }
]

/**
 * Replaces global configuration placeholders in the string of text.
 *
 * @export
 * @param {String} text
 * @returns {String}
 */
export function replace(text) {
  REPLACEMENTS.forEach(r => {
    if (r.pattern.test(text)) {
      text = text.replace(r.pattern, r.replace())
    }
  })
  return text
}



// WEBPACK FOOTER //
// /home/runner/work/web-interactive/web-interactive/lib/config/placeholder.js